export class UnitData{
	id:string;
	className:string;
	symbol:string;
	constructor(id:string,className:string,symbol:string){
		this.setId(id);
		this.setClassname(className);
		this.setSymbol(symbol);
	}
	setId(id:string):void{
		this.id = id;
	}
	setClassname(cn:string):void{
		switch(cn.toLowerCase()){
			case 'kw':
			{
				this.className = 'kW';
				return;
			}
			case 'kwh':{
				this.className = 'kWh';
				return;
			}
			case 'degc':{
				this.className = 'degC';
				return;
			}
			case 'kWhd':{
				this.className = 'kWhd';
				return;
			}
			default:{
				this.className = cn;
				return;
			}
		}
	}
	setSymbol(s:string):void{
		this.symbol = s;
	}
	getId():string{
		return this.id;
	}
	getClassName():string{
		return this.className;
	}
	getSymbol():string{
		return this.symbol;
	}
}
